// ==================== SERVICIO DE NOMBRES DE PLANTILLA ====================
// Nombres (texto) de subcontratos/materiales de la plantilla por defecto, para autocompletar formularios

import api, { ejecutarConReintentos } from './api';

const plantillasNombresService = {
  // ==================== OBTENER NOMBRES DE PLANTILLA ====================
  async obtenerNombresPlantillas() {
    try {
      const response = await ejecutarConReintentos(async () => {
        return await api.get('/plantillas/nombres');
      });

      return {
        subcontratos: response.data.subcontratos || [],
        materiales: response.data.materiales || [],
      };
    } catch (error) {
      console.error('❌ Error al obtener nombres de plantilla:', error.response?.data || error.message);
      throw error.response?.data || { error: 'Error al obtener nombres de plantilla' };
    }
  },
};

export default plantillasNombresService;
